import { render, staticRenderFns } from "./newsdetail2.vue?vue&type=template&id=0d2ec5d4&scoped=true"
import script from "./newsdetail2.vue?vue&type=script&lang=js"
export * from "./newsdetail2.vue?vue&type=script&lang=js"
import style0 from "./newsdetail2.vue?vue&type=style&index=0&id=0d2ec5d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2ec5d4",
  null
  
)

export default component.exports